import { render, staticRenderFns } from "./ExternalAttachmentsSettings.vue?vue&type=template&id=1cc1719e&"
import script from "./ExternalAttachmentsSettings.vue?vue&type=script&lang=js&"
export * from "./ExternalAttachmentsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports